import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
/* eslint-disable react-hooks-ssr/react-hooks-global-ssr */

import { useState } from 'react';
import ReactDOM from 'react-dom';
/**
 * Portal
 *
 * Render a React tree in a different DOM hierarchy to prevent
 * parent styles from clipping or hiding content, such as
 * with Popovers, Tooltips, etc.
 */

export function Portal(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children;

  var _useState = useState(function () {
    // prevent blowing up on the server
    if (typeof document === 'undefined') {
      return null;
    }

    return document.body;
  }),
      _useState2 = _slicedToArray(_useState, 1),
      target = _useState2[0];

  if (disabled || !target) {
    return children;
  }

  return ReactDOM.createPortal(children, target);
}